<template>
  <div class="stepper">
    <el-button
      type="text"
      icon="el-icon-remove-outline"
      circle
      v-if="!isZero()"
      @click="cmd0"
    />

    <span class="qty" v-if="!isZero()">{{ Number(s2.Qty) }}</span>

    <el-button
      type="text"
      icon="el-icon-circle-plus-outline"
      circle
      @click="cmd1"
      :disabled="isStopSale(s2.ItemName)"
    />
    <span class="text-size" @click="cmd1">
      {{ s2.DispName }}
      <span class="C1" v-if="s2.Price1 != 0"> +${{ s2.Price1 }}</span>
    </span>
    <span v-if="isStopSale(s2.ItemName)"> 售完</span>
  </div>
</template>

<style scoped>
.stepper {
  line-height: 3rem;
  text-align: left;
}
.qty {
  font-size: 1.6rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.el-button {
  margin: 0;
  padding: 0;
  font-size: 1.6rem;
  color: v-bind(sGetConfig("color2"));
}
</style>

<script>
export default {
  props: {
    s2: Object,
  },
  methods: {
    onChange() {
      this.$emit("change", this.s2);
    },
    isZero() {
      if (this.s2.Qty < 1) {
        return true;
      }
      return false;
    },
    cmd0() {
      this.s2.Qty--;
      this.onChange();
    },
    cmd1() {
      this.s2.Qty++;
      this.onChange();
    },
    isStopSale(itemname) {
      const find = this.$store.state.sStopSale.find((r) => r.ItemName == itemname);
      return find;
    },
  },
};
</script>
